import * as O from "fp-ts/Option";
import * as M from ".";
import { Fold, Iso, Prism, Review, Setter, Traversal, } from "../../control/lens";
export const _Just = () => Prism.prism(Traversal.traversal(Fold.fold((fold, empty, e) => M.reduce((a, b) => fold(b, a), empty, e)), Setter.setter((g) => (m) => M.map(g, m), (a) => () => M.of(a))), Review.review(M.of));
export const non = () => Iso.iso((m) => O.toUndefined(m), O.fromNullable);

